import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal",
  ref: "infoModal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "modal-footer" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Order")
], -1)
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "table table-striped table-hover" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("th", null, "Namn:", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", null, "Inskickad:", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Kommentar till butikschef:", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Handlingslista")
], -1)
const _hoisted_14 = {
  key: 1,
  class: "row",
  id: "shopping-list-wrapper"
}
const _hoisted_15 = { class: "table table-striped table-hover mb-0" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Vara"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Mängd"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "d-none d-md-block" }, "Kommentar till butiken"),
      /*#__PURE__*/_createElementVNode("span", { class: "d-block d-md-none" }, "Kommentar")
    ])
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h5", null, "Generell kommentar till butiken:")
], -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row mt-2" }
const _hoisted_20 = { class: "col-sm-4 offset-sm-8" }
const _hoisted_21 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, _toDisplayString(_ctx.modalContent.body), 1),
            (_ctx.modalContent.err)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.modalContent.err), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.closeModal()), ["prevent"]))
            }, " OK ")
          ])
        ])
      ])
    ], 512),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1))),
      class: "btn btn-link"
    }, " ← Tillbaka "),
    _hoisted_7,
    (_ctx.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _hoisted_10,
                _createElementVNode("td", null, _toDisplayString(_ctx.order.shoppingList?.name), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_11,
                _createElementVNode("td", null, _toDisplayString(_ctx.order.submittedAt.format("YYYY-MM-DD HH:mm:ss")), 1)
              ]),
              _createElementVNode("tr", null, [
                _hoisted_12,
                _createElementVNode("td", null, _toDisplayString(_ctx.order.comment || "-"), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    (_ctx.shoppingList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("table", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shoppingList.rows, (row) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: row.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(row.text), 1),
                  _createElementVNode("td", null, _toDisplayString(row.amount), 1),
                  _createElementVNode("td", null, _toDisplayString(row.comment), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.shoppingList && _ctx.shoppingList.comment)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, _toDisplayString(_ctx.shoppingList.comment), 1)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.resubmit()), ["prevent"])),
          disabled: _ctx.resubmitting,
          class: "btn btn-primary d-block w-100"
        }, " Skicka in igen ", 8, _hoisted_21)
      ])
    ])
  ]))
}